module.exports = "<file-download-page></file-download-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appFileDownload.html
// module id = 2066
// module chunks = 0